/** Plate proof: pure helpers shared by the client and the server (incl. the one "is this photo a data plate?" rule). */
export * from './composedSave';
export * from './plateRow';
